export default "__VITE_ASSET__Bqdmlm0M__"